import React from 'react';
import PropTypes from 'prop-types';
import {
  PieChart, Pie, Sector, Cell
} from 'recharts';
import { chartColors } from '../../helpers/const'

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';
  const name = payload.name
  const splitText = name.replace(/.{10}\S*\s+/g, '$&@').split(/\s+@/)

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />

      {name && (
        <React.Fragment>
          <Sector
            cx={cx}
            cy={cy}
            startAngle={startAngle}
            endAngle={endAngle}
            innerRadius={outerRadius + 6}
            outerRadius={outerRadius + 10}
            fill={fill}
          />

          <path
            d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
            stroke={fill}
            fill="none"
          />

          <circle
            cx={ex}
            cy={ey}
            r={2}
            fill={fill}
            stroke="none"
          />

          <text
            width="50"
            x={ex + (cos >= 0 ? 1 : -1) * 12}
            y={ey - 10}
            textAnchor={textAnchor}
            fill="#333"
          >
            {splitText.map(text => {
              return <tspan key={text} x={ex + (cos >= 0 ? 1 : -1) * 12} dy="15px">{text}</tspan>
            })} - <tspan className="bold">{`${(percent * 100).toFixed(2)}%`}</tspan>
          </text>
        </React.Fragment>
      )}
    </g>
  );
};

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    }
  }

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  render() {
    const {
      data,
      height,
      hideLabel,
      innerRadius,
      outerRadius,
      width
    } = this.props;

    const { activeIndex } = this.state;

    return (
      <React.Fragment>
        <PieChart width={width} height={height}>
          <Pie
            activeIndex={activeIndex}
            activeShape={!hideLabel && renderActiveShape}
            data={data}
            cx={width / 2}
            cy={height / 2}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            fill="#00C49F"
            dataKey="value"
            onMouseEnter={this.onPieEnter}
          >
            {
              data.map((entry, index) => <Cell key={`cell-${index}`} fill={chartColors[index % chartColors.length]} />)
            }
          </Pie>
        </PieChart>
      </React.Fragment>
    )
  }
}

Chart.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  innerRadius: PropTypes.number.isRequired,
  outerRadius: PropTypes.number.isRequired
};

export default Chart
